var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-fade-transition',[_c('v-overlay',{attrs:{"absolute":_vm.absolute,"color":"white","opacity":"0.7"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }